import { Button } from 'antd'
import styled from 'styled-components'

export const UppercaseButton = styled(Button)`
  text-transform: uppercase;
  box-shadow: ${props => props.noShadow && 'none'};
`
